import { Component } from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'

import {
  getRegistryDescription,
  getRegistryId,
  getRegistryPhoto,
  getRegistryTitle,
  getRegistryUrlSlug,
} from 'registry/reducers'
import { savePersonalizeRegistry } from 'registry/actions'

import { Form } from 'components/forms'
import { SaveButton } from 'components/buttons'
import { ModalFooter } from 'components/modal'
import RegistryInfoFieldset from 'registry/forms/registry-info-fieldset'
import withCurrentUser from 'shared/HOC/withCurrentUser'
import PhotoUploader from '../photo-uploader'

export class PersonalizeRegistry extends Component {
  static propTypes = {
    fields: PropTypes.shape({
      registry: PropTypes.shape({
        description: PropTypes.object,
        title: PropTypes.object,
        photoUrl: PropTypes.object,
        urlSlug: PropTypes.object,
      }),
    }),
    submitting: PropTypes.bool,
    handleSubmit: PropTypes.func,
    currentUser: PropTypes.object,
    setCurrentUser: PropTypes.func,
  }

  render() {
    const { handleSubmit, submitting } = this.props

    const helpBlock = (
      <div className="h6 mvn">
        Upload a photo that shares your excitement with your shower guests.
      </div>
    )

    return (
      <Form onSubmit={handleSubmit(this._handleSubmit.bind(this))}>
        <PhotoUploader
          {...this.props.fields.registry.photoUrl}
          className="pbl"
          label="Registry Photo"
          helpText={helpBlock}
        />

        <RegistryInfoFieldset
          description={this.props.fields.registry.description}
          title={this.props.fields.registry.title}
          urlSlug={this.props.fields.registry.urlSlug}
        />

        <ModalFooter>
          <SaveButton submitting={submitting} block />
        </ModalFooter>
      </Form>
    )
  }

  _handleSubmit(values, dispatch) {
    const { currentUser, setCurrentUser } = this.props

    setCurrentUser({
      ...currentUser,
      currentRegistry: {
        ...currentUser?.currentRegistry,
        title: values.registry.title,
        photoUrl: values.registry.photoUrl,
      },
    })

    return dispatch(savePersonalizeRegistry(values))
  }
}

export default reduxForm(
  {
    form: 'PersonalizeRegistryForm',
    fields: [
      'registry.description',
      'registry.id',
      'registry.photoUrl',
      'registry.title',
      'registry.urlSlug',
    ],
  },
  (state) => {
    return {
      initialValues: {
        registry: {
          description: getRegistryDescription(state),
          id: getRegistryId(state),
          photoUrl: getRegistryPhoto(state),
          title: getRegistryTitle(state),
          urlSlug: getRegistryUrlSlug(state),
        },
      },
    }
  }
)(withCurrentUser(PersonalizeRegistry))
